import React, { useState, useRef, useEffect } from "react";
import { Drawer, Form, DatePicker, Select } from "antd";
import axios from "axios";
import moment from "moment";

const { Option } = Select;

const DrawerAta = ({ visible, form, onClose, onConfirm }) => {
    const [dataEmissao, setDataEmissao] = useState(moment());
    const [disciplinas, setDisciplinas] = useState([]);
    const [disciplina, setDisciplina] = useState(undefined);

    const hasFetched = useRef(false);

    const { getFieldDecorator } = form;

    const handleChangeDataEmissao = date => {
        setDataEmissao(date);
    };

    const handleChangeDisciplina = value => {
        const disciplina = disciplinas.find(x => x.id === value);
        setDisciplina(disciplina.id);
    };

    const afterVisibleChange = visible => {
        if (!visible) {
            form.resetFields();
            setDataEmissao(moment());
        }
    };

    const getDisciplinas = () => {
        axios({
            method: "get",
            url: "/api/aulas-exportar/get-disciplinas",
            params: {
                id: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setDisciplinas(response.data);
            })
            .catch(() => {});
    };

    useEffect(() => {
        if (!hasFetched.current) {
            getDisciplinas();
            hasFetched.current = true;
        }
    }, []);

    return (
        <>
            <Drawer
                className="drawer-inscrever"
                width={720}
                onClose={onClose}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
                afterVisibleChange={afterVisibleChange}
            >
                <div className="bloco-drawer-associar">
                    <Form className="form-emitir-declaracao">
                        <Form.Item label="Data de emissão">
                            {getFieldDecorator("dataEmissao", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ],
                                initialValue: dataEmissao
                            })(
                                <DatePicker
                                    name="dataEmissao"
                                    format="DD-MM-YYYY"
                                    placeholder="Selecionar"
                                    suffixIcon={false}
                                    clearIcon={false}
                                    onChange={handleChangeDataEmissao}
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="Disciplinas">
                            {getFieldDecorator("disciplinas", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(
                                <Select
                                    placeholder="Selecionar Opção"
                                    onChange={handleChangeDisciplina}
                                    className="custom-select ant-select-selection--single"
                                >
                                    {disciplinas.map(disciplina => (
                                        <Option key={disciplina.id} value={disciplina.id}>
                                            {disciplina.nome}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Form>
                </div>
                <div className="ant-drawer-footer">
                    <button className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                        Voltar
                    </button>
                    <button
                        className="botao-principal"
                        disabled={!dataEmissao || disciplina === undefined}
                        type="primary"
                        onClick={() => {
                            onConfirm(disciplina, dataEmissao);
                            setDisciplina(undefined);
                        }}
                    >
                        Visualizar
                    </button>
                </div>
            </Drawer>
        </>
    );
};

const FormDrawerAta = Form.create({ name: "drawer-ata" })(DrawerAta);

export default FormDrawerAta;
